import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="footer">
      <button
        className={`footer__item ${pathname === '/employee/reports' ? 'footer__item--active' : ''}`}
        onClick={() => navigate('/employee/reports')}
      >
        <span className="footer__icon">🏠</span>
        <span className="footer__label">Home</span>
      </button>
      <button
        className={`footer__item ${pathname === '/employee/profile' ? 'footer__item--active' : ''}`}
        onClick={() => navigate('/employee/profile')}
      >
        <span className="footer__icon">👤</span>
        <span className="footer__label">Profile</span>
      </button>
    </nav>
  );
};

export default Footer;
